/**
 * The colour each macro is keyed by, wherever one is shown: the chip in a
 * table header, the bar beside a total, the header of a dish row.
 *
 * One place rather than one per table. Four copies of these hex codes is how
 * the plan list and the plan builder quietly stop agreeing on what blue means
 * — and the labels beside them differ per screen ("Calories", "Cal.", "Total
 * calories"), so it is the colours that are shared and nothing else.
 *
 * The order the four are read in is the caller's: the list table shows protein
 * before carbs, the builder shows carbs before protein.
 */

import type { Macros } from "./types/plans.types";

export const MACRO_COLORS: Record<keyof Macros, string> = {
  calories: "#FE8C1A",
  carbs: "#3291F0",
  protein: "#02C98D",
  fat: "#FB3A7D",
};
